import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";

export const TagsRelated = () => {

    const dataContext = useContext(TemplateContext);
    const { content: formatContent } = dataContext || {};

    return (
        <>
            {(formatContent?.tagsRelated?.length > 0 || formatContent?.manualTagsRelated?.length > 0) && (
                <nav>
                    <ul className="related-tags">
                        <p className="desTag">Tags relacionados</p>
                        {formatContent?.tagsRelated?.map((item, index) => (
                            <li key={`tagsRelated-${index}`}>
                                <a href={`/tema/${item.slug}.html`}>{item.name}</a>
                            </li>
                        ))}
                        {formatContent?.manualTagsRelated?.map((item, index) => (
                            <li key={`manualTags-${index}`}>
                                <a href={`${ item.link.includes("https") 
                                    ? item.link 
                                    : item.link.includes("clarin.com") 
                                        ? item.link.replace("clarin.com", process.env.NEXT_PUBLIC_DOMAIN_URL) 
                                        : process.env.NEXT_PUBLIC_DOMAIN_URL + item.link}`}
                                >
                                    {item.name}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
            )}
        </>
    );

}